import { clearCart, getCart } from "@/services/cart"
import useCart from "@/store/cart.store";
import { deleteCookie, setCookie, getCookies } from "cookies-next/client"

export const manageCartAfterLogin = async (isSalesLogin = false) => {
  const { setCart, resetCart } = useCart.getState();
  const { quote, mage } = getCookies()
  const getcartRes = await getCart({ quote, mage })
  const quoteId = getcartRes?.data?.quoteId
  const cart = getcartRes?.data?.data
  if (quoteId && cart) {
    setCookie('quote', quoteId)
    setCart(cart)
  }

  if (isSalesLogin && quoteId && cart?.items?.length > 0) {
    const clearCartRes = await clearCart({ quote: quote || quoteId, mage })
    if (clearCartRes?.data?.status) {
      deleteCookie('quote')
      resetCart()
    }
  }
}